<template>
  <InfoCard
    v-if="phone"
    icon="ui-icon-ui-call"
    class="text-decoration-none"
    :title="`${tStatic('Телефон')}:`"
    :subtitle="formatPhone({ phone, country: context.request.country })"
    :href="isMobile
      ? `tel:${formatPhone({ phone, country: context.request.country, isRaw: true })}`
      : undefined"
    @click="isMobile ? sendYaGoal('mobile_appointment__phone_action') : null"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import type { CommonContextStore } from 'src/types/context'
import useContextStore from 'src/store/useContextStore'
import useYandexGoals from 'src/composables/useYandexGoals'
import getLpuPhone from 'src/utils/getLpuPhone'
import formatPhone from 'src/functions/formatPhone'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'
import InfoCard from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/InfoCard.vue'

const props = defineProps<{
  lpu: Lpu
}>()

const { context }: CommonContextStore = useContextStore()

const phone = computed(() => getLpuPhone({
  lpu: props.lpu,
  lpuAddress: props.lpu.addr[0],
}))
const isMobile = useIsMobile()

const { sendYaGoal } = useYandexGoals()
</script>
